import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { CrashReport } from '../../shared/models/crash.model';


@Injectable({
  providedIn: 'root',
})
export class CrashMonitorService implements ErrorHandler {

  /**
   * Initialize global listeners for unhandled errors and promise rejections.
   */
  initGlobalListeners(): void {
    window.addEventListener('error', (event) => {
      const errorData: CrashReport = {
        message: event.message,
        stack: event.error?.stack ?? null,
        url: window.location.href,
        status: null, 
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      };

      this.logError(errorData);
    });

    window.addEventListener('unhandledrejection', (event) => {
      const reason: any = event.reason;

      const errorData: CrashReport = {
        message: reason?.message || 'Unhandled Promise rejection',
        stack: reason?.stack ?? null,
        url: window.location.href,
        status: null, 
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      };

      this.logError(errorData);
    });
  }


  /**
   * Angular's default error handler override.
   */
  handleError(error: unknown): void {
    let message = 'Unknown error';
    let stack: string | null = null;
    let status: number | string | undefined;

    if (error instanceof Error) {
      message = error.message;
      stack = error.stack ?? null;
    } else if (error instanceof HttpErrorResponse) {
      message = error.message;
      status = error.status;
      stack = error.error?.stack ?? null;
    } else if (typeof error === 'string') {
      message = error;
    }

    const errorData: CrashReport = {
      message,
      stack,
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      ...(status !== undefined ? { status } : {}),
    };

    this.logError(errorData);
  }


  logApiError(error: HttpErrorResponse, url: string): void {
    const errorData: CrashReport = {
      message: error.message,
      stack: error.error?.stack ?? null, 
      url,
      status: error.status ?? null,   
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    };

    this.logError(errorData);
  }


  private logError(errorData: CrashReport): void {
    console.error('[CrashMonitor]', errorData.message, errorData);
  }


}
